export default "__VITE_ASSET__wkVK56Mk__"